import React from "react";
import { useGeoLocation } from "../../hooks/useGeoLocation";
import SectionHeading from "../../ui/components/SectionHeading";
import LocationPicker from "./LocationPicker";

const ContactStep = ({
  transactionalMobile,
  setTransactionalMobile,
  transactionalEmail,
  setTransactionalEmail,
  shopNumber,
  setShopNumber,
  buildingName,
  setBuildingName,
  streetAddress,
  setStreetAddress,
  contactCity,
  setContactCity,
  contactDistrict,
  setContactDistrict,
  contactState,
  setContactState,
  contactPinCode,
  setContactPinCode,
  shippingLatitude,
  shippingLongitude,
  setShippingLatitude,
  setShippingLongitude,
  shippingLocation,
  setShippingLocation,
  errors,
  setErrors,
}) => {
  const { getCurrentPosition, getAddressFromCoords, isCapacitor } =
    useGeoLocation();

  return (
    <div className="step-content">
      <SectionHeading>Transactional Contact</SectionHeading>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="Mobile">
            Mobile <span className="required-asterisk">*</span>
          </label>
          <input
            id="Mobile"
            required
            type="tel"
            pattern="[0-9]{10}"
            maxLength={10}
            placeholder="10-digit mobile number"
            value={transactionalMobile}
            onChange={(e) => setTransactionalMobile(e.target.value)}
          />
          {errors.transactionalMobile && (
            <span className="error-message">{errors.transactionalMobile}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="Email">
            Email <span className="required-asterisk">*</span>
          </label>
          <input
            id="Email"
            required
            type="email"
            placeholder="business@example.com"
            value={transactionalEmail}
            onChange={(e) => setTransactionalEmail(e.target.value)}
            autoComplete="email"
          />
          {errors.transactionalEmail && (
            <span className="error-message">{errors.transactionalEmail}</span>
          )}
        </div>
      </div>
      <SectionHeading style={{ marginTop: "40px" }}>
        Shipping Address
      </SectionHeading>

      <LocationPicker
        shippingLatitude={shippingLatitude}
        setShippingLatitude={setShippingLatitude}
        shippingLongitude={shippingLongitude}
        setShippingLongitude={setShippingLongitude}
        shippingLocation={shippingLocation}
        setShippingLocation={setShippingLocation}
        errors={errors}
        setErrors={setErrors}
        getCurrentPosition={getCurrentPosition}
        getAddressFromCoords={getAddressFromCoords}
        isCapacitor={isCapacitor}
        setContactCity={setContactCity}
        setContactDistrict={setContactDistrict}
        setContactState={setContactState}
        setContactPinCode={setContactPinCode}
      />
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="shopNumber">Shop Number / Flat Number</label>
          <input
            id="shopNumber"
            required
            value={shopNumber}
            onChange={(e) => setShopNumber(e.target.value)}
            error={errors.shopNumber}
          />
        </div>
        <div className="form-group">
          <label htmlFor="buildingName">Building Name</label>
          <input
            id="buildingName"
            required
            value={buildingName}
            onChange={(e) => setBuildingName(e.target.value)}
            error={errors.buildingName}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="streetAddress">Street Address</label>
          <input
            id="streetAddress"
            required
            value={streetAddress}
            onChange={(e) => setStreetAddress(e.target.value)}
            error={errors.streetAddress}
          />
        </div>
        <div className="form-group">
          <label htmlFor="contactCity">City / Village</label>
          <input
            id="contactCity"
            required
            value={contactCity}
            onChange={(e) => setContactCity(e.target.value)}
            error={errors.contactCity}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="contactDistrict">
            District <span className="required-asterisk">*</span>
          </label>
          <input
            id="contactDistrict"
            type="text"
            placeholder="Auto-filled from location"
            value={contactDistrict}
            onChange={(e) => setContactDistrict(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="contactState">State</label>
          <input
            id="contactState"
            type="text"
            value={contactState}
            onChange={(e) => setContactState(e.target.value)}
            error={errors.contactState}
            placeholder="Enter State"
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="contactPinCode">
          Pincode <span className="required-asterisk">*</span>
        </label>
        <input
          id="contactPinCode"
          required
          type="text"
          maxLength={6}
          value={contactPinCode}
          onChange={(e) =>
            setContactPinCode(e.target.value.replace(/[^0-9]/g, ""))
          }
          error={errors.contactPinCode}
        />
      </div>
    </div>
  );
};

export default React.memo(ContactStep);
